import React from 'react';

const TermsConditions = () => {
  return (
    <div>
      <h1>TermsConditions</h1>
      <p>TermsConditions page content goes here.</p>
    </div>
  );
};

export default TermsConditions;